import RichUpdatesTimelineItem from './RichUpdatesTimelineItem';

export default RichUpdatesTimelineItem;
